// TICKET-703: shared client-side activity_log writer. Same row shape
// lib/handlers/bundles.js already writes server-side (stage_change) — this is
// the client-side counterpart for writes that happen from src/lib/api/*
// without a server `profile` object in scope. Fire-and-forget audit trail:
// never throws, never blocks or fails the caller's own mutation.
import { supabase } from '../supabase';

export async function logActivity({ entityType, entityId, entityName, action, oldValue, newValue, metadata }) {
  try {
    const { data: { user } = {} } = await supabase.auth.getUser();
    if (!user) {
      await supabase.from('activity_log').insert({
        entity_type: entityType,
        entity_id: entityId,
        entity_name: entityName || '',
        action,
        old_value: oldValue ?? null,
        new_value: newValue ?? null,
        actor_id: null,
        actor_name: '',
        metadata: metadata || null,
      });
      return;
    }
    let actorName = user.email || '';
    try {
      const { data: prof } = await supabase.from('user_profiles').select('display_name').eq('id', user.id).single();
      if (prof?.display_name) actorName = prof.display_name;
    } catch { /* spine-emit-ok: profile lookup best-effort for audit actor name */ }

    await supabase.from('activity_log').insert({
      entity_type: entityType,
      entity_id: entityId,
      entity_name: entityName || '',
      action,
      old_value: oldValue ?? null,
      new_value: newValue ?? null,
      actor_id: user.id,
      actor_name: actorName,
      metadata: metadata || null,
    });
  } catch (e) { console.warn('[activityLog] insert failed:', e?.message); /* spine-emit-ok: audit insert non-fatal */ }
}
